import { api } from './api';

export const meetingFormatService = {
    async getAllFormats() {
        try {
            const response = await api.get('/meeting-formats');
            return response.data;
        } catch (error) {
            console.error('Error fetching meeting formats:', error);
            throw error;
        }
    },

    async getFormatById(id) {
        try {
            const response = await api.get(`/meeting-formats/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching meeting format:', error);
            throw error;
        }
    },

    async createFormat(formatData) {
        try {
            const response = await api.post('/meeting-formats', {
                format: {
                    name: formatData.name,
                    description: formatData.description,
                    default_duration_minutes: formatData.default_duration_minutes
                },
                segments: formatData.segments
            });
            return response.data;
        } catch (error) {
            console.error('Error creating meeting format:', error);
            throw error;
        }
    },

    async updateFormat(id, formatData) {
        try {
            const response = await api.put(`/meeting-formats/${id}`, {
                format: {
                    name: formatData.name,
                    description: formatData.description,
                    default_duration_minutes: formatData.default_duration_minutes
                },
                segments: formatData.segments
            });
            return response.data;
        } catch (error) {
            console.error('Error updating meeting format:', error);
            throw error;
        }
    },

    async toggleFormat(id) {
        try {
            const response = await api.post(`/meeting-formats/${id}/toggle`);
            return response.data;
        } catch (error) {
            console.error('Error toggling meeting format:', error);
            throw error;
        }
    },

    async cloneFormat(id) {
        try {
            const response = await api.post(`/meeting-formats/${id}/clone`);
            return response.data;
        } catch (error) {
            console.error('Error cloning meeting format:', error);
            throw error;
        }
    }
};
